import { forwardRef } from 'react'
import { Platform, ScrollView, type ScrollViewProps } from 'react-native'

export const FormScrollView = forwardRef<ScrollView, ScrollViewProps>(
  ({ keyboardDismissMode, keyboardShouldPersistTaps, ...props }, ref) => (
    <ScrollView
      ref={ref}
      keyboardDismissMode={keyboardDismissMode ?? (Platform.OS === 'ios' ? 'interactive' : 'on-drag')}
      keyboardShouldPersistTaps={keyboardShouldPersistTaps ?? 'handled'}
      {...props}
    />
  )
)

FormScrollView.displayName = 'FormScrollView'
